import { Typography, useTheme } from '@mui/material'
import { SelectionListItem } from '../settings-selection-list.constants'
import { SettingsSelectionListItemContainer } from './settings-selection-list-item.styles'

type Props = {
  index: number
  handleIndex: (index: number) => void
} & SelectionListItem

const SettingsSelectionListItem = ({
  id,
  label,
  index,
  handleIndex,
}: Props) => {
  const theme = useTheme()

  const isselected = (id === index).toString()

  const handleClick = () => {
    handleIndex(id)
  }

  return (
    <SettingsSelectionListItemContainer
      isselected={isselected}
      theme={theme}
      onClick={handleClick}
    >
      <Typography>{label}</Typography>
    </SettingsSelectionListItemContainer>
  )
}

export default SettingsSelectionListItem
